import { Divider, ListItemIcon, Menu, MenuItem } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faClone, faTrashCan } from "@fortawesome/pro-light-svg-icons"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"

const useStyles = makeStyles()((theme) => ({
    menuPaper: {
        minWidth: "14rem",
        borderRadius: ".75rem",
    },
    divider: {
        marginTop: ".5rem",
        marginBottom: ".5rem",
    },
    kebabMenuItem: {
        "&.MuiMenuItem-root": {
            minHeight: "auto",
            paddingTop: ".75rem",
            paddingBottom: ".75rem",
        },
    },
    kebabItemIcon: {
        minWidth: "2rem",
        color: theme.palette.tailwind.slate[500],
    },
    deleteItem: {
        color: theme.palette.error.main,
    },
}))

type Props = Readonly<{
    anchorEl: HTMLElement | null
    onClose: () => void
    onDuplicate: () => void
    onDelete: () => void
}>

export function OrderKebabMenu({ anchorEl, onClose, onDuplicate, onDelete }: Props) {
    const { classes, cx } = useStyles()

    const runAndClose = (action: () => void) => () => {
        action()
        onClose()
    }

    return (
        <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            slotProps={{ paper: { className: classes.menuPaper } }}
        >
            <MenuItem className={classes.kebabMenuItem} onClick={runAndClose(onDuplicate)}>
                <ListItemIcon className={classes.kebabItemIcon}>
                    <FontAwesomeIcon icon={faClone} />
                </ListItemIcon>
                <LocalizedStrict id="meeting-service-order-drawer-duplicate">
                    <span>Duplicate</span>
                </LocalizedStrict>
            </MenuItem>
            <Divider className={classes.divider} />
            <MenuItem className={cx(classes.kebabMenuItem, classes.deleteItem)} onClick={runAndClose(onDelete)}>
                <ListItemIcon className={cx(classes.kebabItemIcon, classes.deleteItem)}>
                    <FontAwesomeIcon icon={faTrashCan} />
                </ListItemIcon>
                <LocalizedStrict id="meeting-service-production-view-card-delete-button">
                    <span>Delete</span>
                </LocalizedStrict>
            </MenuItem>
        </Menu>
    )
}
